import { Search, X } from "lucide-react";
import { Input } from "../shadcn/Input";
import { cn } from "../../utils/css";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  className,
}: SearchInputProps) => {
  return (
    <div className={cn("relative", className)}>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={value ? "pr-16" : "pr-9"}
      />
      <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {value && (
          <X
            className="h-4 w-4 cursor-pointer opacity-50 hover:opacity-100"
            onClick={() => onChange("")}
          />
        )}
        <Search className="h-4 w-4 opacity-50" />
      </div>
    </div>
  );
};

export default SearchInput;
